import { render, staticRenderFns } from "./FormTrigger.vue?vue&type=template&id=48a9879d&"
import script from "./FormTrigger.vue?vue&type=script&lang=js&"
export * from "./FormTrigger.vue?vue&type=script&lang=js&"
import style0 from "./FormTrigger.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports